import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export enum STATUS {
  SENDING = 0,
  DONE = 1,
  // eslint-disable-next-line no-magic-numbers
  FAIL = 2
}

export interface QueryParams {
  task_id: string // 任务id
  page: number // 页码
  limit: number // 每页数量
  status: number // 状态 0-进行中,1-完成,2-失败
}

export interface List {
  device_id: string // 终端设备id
  computer_name: string // 计算机名
  user_mark: string // 登记用户名
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  mac: string // mac地址
  login_status: number // 终端状态
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  group_name: string // 分组名称
}

export interface ResponseData {
  list: List[]
  total: number // 总数
}

@Injectable()
export class TerminalOrderTaskDetailService {
  constructor (private http: Http) {}
  @ParamsClean()
  getTerminalOrderTaskDetail (data: QueryParams) {
    return this.http.post<ResponseData>('/terminal-order/task-detail', data)
  }
}
